import { api } from "./api";
import { orderPaymentEndPoints } from "../constants/endpoints";

import { getApiOrganizationId } from "../utils/orgIdUtils";

export const updateOrderPaymentApi = async (payload: any, id: string) => {
  try {
    const endpointUrl = `${orderPaymentEndPoints.updateOrderPayment}/${id}`;
    return await api.put(endpointUrl, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error: any) {
    throw Error(error);
  }
};
